import CustomPlainBtn from "../../../components/fragments/CustomPlainBtn";
import KitchenTable from "../../../components/kitchen/KitchenTable";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import Select from "react-select";
import CustomInputSearch from "../../../components/fragments/CustomInputSearch";
import moment from "moment";
import { useParams } from "react-router-dom";
const optionsMap = {
  "": "",
  1: "DINE_IN",
  2: "TAKEAWAY",
  3: "DELIVERY",
};
export default function KitchenHistoryPage() {
  const [tabList, setTabList] = useState(["ออเดอร์ที่สำเร็จ", "ออเดอร์ที่ยกเลิก"]);
  const [tabIndex, setTabIndex] = useState(0);
  const currentDate = moment().format("YYYY-MM-DD");
  const navigate = useNavigate();
  const [filterText, setFilterText] = useState("");
  const [date, setDate] = useState(currentDate);
  const [Delivery, setDelivery] = useState("");
  const currentBranchPos = localStorage.getItem("branchKitchenId");
  const { businessSlug } = useParams();
  const [params, setParams] = useState({ statusKitchen: "", date: currentDate, search: "", sortBy: "created_at", sortOrder: "desc" });
  const optionsDelivery = [
    { value: "", label: "ทั้งหมด" },
    { value: 1, label: "ทานที่ร้าน" },
    { value: 2, label: "กลับบ้าน" },
    { value: 3, label: "เดลิเวอรี่" },
  ];
  useEffect(() => {
    const updateOptions = optionsMap[Delivery];
    const currentStatus = tabIndex === 0 ? "SUCCESS" : "CANCEL";
    setParams({
      statusKitchen: currentStatus,
      date: date,
      search: filterText,
      sortBy: "created_at",
      sortOrder: "desc",
      orderType: updateOptions,
    });
  }, [filterText, date, currentBranchPos, Delivery, tabIndex]);

  return (
    <div className="px-[min(1.56vw,16px)]">
      {/* header */}
      <div className="py-[min(2.60vw,26.62px)]  ">
        <div className="flex mb-3 items-center">
          <button
            onClick={() => navigate(-1)}
            className="flex justify-center items-center aspect-square w-[min(3.01vw,30.8px)] h-fit border-[#2DC76D] border-[min(0.10vw,1px)] rounded-[min(0.39vw,4px)] mr-[min(2.65vw,8.4px)]"
          >
            <img className="object-contain aspect-[15.4/8.79] w-[min(1.50vw,15.4px)] h-fit" src="/img/icons/icon-arrow-left-green.svg" alt="" />
          </button>
          <div className="text-[#2DC76D]">กลับหน้าหลัก</div>
        </div>

        <div className="text-xl font-bold text-[#171618]">ประวัติการสั่งซื้อ</div>
        <div className="flex gap-[min(1.95vw,20px)] mt-[min(2.28vw,23.38px)]">
          <div
            onClick={() => setTabIndex(0)}
            className={`cursor-pointer text-18 font-bold px-[min(2.47vw,25.25px)] h-[min(4.98vw,51px)] rounded-[min(0.78vw,8px)]  flex items-center space-x-2 overflow-hidden  hover:bg-[#2192FF] ${
              tabIndex == 0 ? "bg-[#2DC76D] text-white" : "border-gray-300 border-2 text-black"
            }`}
          >
            <img src="/img/icons/list-white.svg" alt="" className="flex-shrink-0 translate-y-[2px]" />
            <span className="whitespace-nowrap">ออเดอร์ที่สำเร็จ</span>
          </div>

          <div
            onClick={() => setTabIndex(1)}
            className={`cursor-pointer text-18 font-bold px-[min(2.47vw,25.25px)] h-[min(4.98vw,51px)] rounded-[min(0.78vw,8px)]  hover:border-0 hover:border-transparent flex items-center space-x-2 overflow-hidden hover:bg-[#2192FF] hover:text-white group ${
              tabIndex == 1 ? "bg-[#2DC76D] text-white" : "border-gray-300 border-2"
            }`}
          >
            <div className="relative group flex-shrink-0 translate-y-[2px]">
              <img src={`${tabIndex == 1 ? "/img/icons/time-white.svg" : "/img/icons/time-grey.svg"}`} alt="" className="flex-shrink-0 group-hover:hidden" />
              <img src="/img/icons/time-white.svg" alt="" className="flex-shrink-0 hidden group-hover:flex" />
            </div>
            <span className="whitespace-nowrap">ออเดอร์ที่ยกเลิก</span>
          </div>
        </div>

        <div className="flex pt-2 mt-3  items-center">
          <div className="pe-3">
            <DateRangePicker
              initialSettings={{ singleDatePicker: true }}
              onCallback={(start, end, label) => {
                setDate(start.format("YYYY-MM-DD"));
              }}
            >
              <input type="text" className="form-control input-calendar mb-2" />
            </DateRangePicker>
          </div>
          <div className="d-flex align-items-center mb-2">
            <div className="form-select-image-2  me-2">
              <Select
                className={` selectedimg  select-arrow   selectedimg-${Delivery} `}
                defaultValue={optionsDelivery[0]}
                options={optionsDelivery}
                onChange={(e) => {
                  setDelivery(e.value);
                }}
                value={optionsDelivery.filter((item) => item.value == Delivery)}
                placeholder=""
              />
            </div>
            <div className="fs-14 fw-500 text-white px-3 py-1 ms-2 me-3" style={{ borderRadius: "8px", background: "#FF731D" }}>
              POS1
            </div>
          </div>
          <CustomInputSearch
            inputprops={{
              type: "text",
              className: "search-input text-12 w-100 pt-2  mb-2",
              placeholder: "ค้นหาหมายเลขออเดอร์",
              min: 0,
              onChange: (e) => {},
            }}
            onKeyUp={(e) => setFilterText(e.target.value)}
          />
        </div>
      </div>

      {/* body */}
      <KitchenTable tabIndex={tabIndex} params={params} businessSlug={businessSlug} currentBranchPos={currentBranchPos} />
    </div>
  );
}
